import { useId, useState } from "react";
import { RegularModal } from "@/components/modals/modals";
import { RestaurantItemModalModifierSelection } from "@/app/(shop)/menu/[slug]/components/restaurantModalModifierSelection";
import useMediaQuery from "@/utils/useMediaQuery";
import { useSearchParams } from "next/navigation";
import { OrderType } from "@/constants/enum";
import { isBusinessOpen } from "@/utils/isBusinessOpenUtil";
import { SelectedModifiers } from "@/dto/selectedModifiers";
import { getMerchantBusinessHours } from "@/utils/scheduleOrderUtils";
import { ImageModalCloseButton } from "@/components/_icons/imageModalCloseButton";
import CloseIcon from "@/components/_icons/closeIcon";
import { useScrollObserver } from "@/utils/useScrollObserver";
import { useTranslations } from "next-intl";

export const RestaurantItemModal = ({
  merchant,
  isCheckoutEnabled,
  isOpen,
  onRequestClose,
  item,
  modifiers,
  menu,
  isAcceptingOrders,
  merchantColor,
  isRunningTabsEnabled,
  isEssentials,
  selectedDayPart,
}: any) => {
  const searchParams = useSearchParams();
  const t = useTranslations("restaurantMenu");
  const [selectedModifiers, setSelectedModifiers] = useState<SelectedModifiers>(
    {}
  );
  const [quantity, setQuantity] = useState(1);
  const isMobileScreen = useMediaQuery("(max-width: 640px)");
  const isDineIn =
    searchParams?.get("order_type")?.toLowerCase() ===
    OrderType.DINE_IN.toLowerCase();
  const editingCartId = searchParams?.get("cartId") ?? null;
  const isMerchantOpen = isBusinessOpen(merchant, isDineIn);
  const businessHours = getMerchantBusinessHours(merchant);
  const titleId = useId();
  const subtitleId = useId();
  const {
    containerRef,
    targetRef: imageRef,
    isIntersecting: isImageInView,
  } = useScrollObserver(0);

  const productImage =
    item.images && item.images.length > 0
      ? item.images.reduce((prev: any, current: any) => {
          if (
            current.name.includes("xxxhdpi") ||
            (current.name.includes("xxhdpi") &&
              !prev.name.includes("xxxhdpi")) ||
            (current.name.includes("xhdpi") &&
              !prev.name.includes("xxhdpi") &&
              !prev.name.includes("xxxhdpi"))
          ) {
            return current;
          }
          return prev;
        }, item.images[0])
      : null;

  return (
    <RegularModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="sm:p-4"
      overlayClassName="bg-opacity-0"
      contentClassName="bg-white sm:rounded-lg shadow-lg w-full max-w-full h-[100%] sm:h-auto sm:w-auto mx-auto overflow-hidden"
      closeIcon={
        productImage && isImageInView ? (
          <ImageModalCloseButton />
        ) : (
          <CloseIcon />
        )
      }
      focusElementId={titleId}
      contentLabel={t("menuItemDetails")}
    >
      <RestaurantItemModalModifierSelection
        isCheckoutEnabled={isCheckoutEnabled}
        onRequestClose={onRequestClose}
        productImage={productImage}
        item={item}
        menu={menu}
        modifiers={modifiers}
        selectedModifiers={selectedModifiers}
        setSelectedModifiers={setSelectedModifiers}
        quantity={quantity}
        setQuantity={setQuantity}
        isAcceptingOrders={isAcceptingOrders}
        merchantColor={merchantColor}
        isRunningTabsEnabled={isRunningTabsEnabled}
        isMobileScreen={isMobileScreen}
        isEssentials={isEssentials}
        isMerchantOpen={isMerchantOpen}
        selectedDayPart={selectedDayPart}
        timezone={merchant.timezone}
        editingCartId={editingCartId}
        businessHours={businessHours}
        imageRef={imageRef}
        scrollContainerRef={containerRef}
        titleId={titleId}
        subtitleId={subtitleId}
      />
    </RegularModal>
  );
};
